<template>
<q-expansion-item
  v-model="state.unfold"
  class="full-width"
  @show="listen__x__ontoggle($event, true)"
  @hide="listen__x__ontoggle($event, false)">
  <template v-slot:header>
    <q-item-section avatar>
      <q-icon name="label_important" :style="{color:field.color}" />
    </q-item-section>

    <q-item-section>
      <div class="row">
        {{ field.key != undefined ? field.key : field.name }}
      </div>
      <div class="text-caption text-grey row" style="justify-content:space-between;">
        <span style="word-break: break-all;">{{ `"${field.value}"` }}</span>
        <span v-if="field.probability != undefined" class="text-blue col row reverse" style="min-width:40px;">{{ `${(parseFloat(field.probability) * 100).toFixed(1)}%` }}</span>
      </div>
    </q-item-section>
  </template>
  <q-card class="full-width">
    <q-card-section class="full-width" style="padding:10px 32px 16px 32px;">
      <div v-if="field.key != undefined" class="item-row">
        <div>key</div>
        <div><span class="text-caption text-grey">
          {{ `"${field.key}"` }}
        </span></div>
      </div>
      <div v-if="field.keyOriginal != undefined" class="item-row">
        <div>keyOriginal</div>
        <div><span class="text-caption text-grey">
          {{ `"${field.keyOriginal}"` }}
        </span></div>
      </div>
      <div class="item-row">
        <div style="margin-right:15px;">value</div>
        <div class="row"><span class="text-caption text-grey" style="word-break: break-all;line-height:1;">
          {{ `"${field.value}"` }}
        </span></div>
      </div>
      <div v-if="field.valueOriginal != undefined" class="item-row">
        <div style="margin-right:15px;">valueOriginal</div>
        <div class="row"><span class="text-caption text-grey" style="word-break: break-all;line-height:1;">
          {{ `"${field.valueOriginal}"` }}
        </span></div>
      </div>
      <div class="my-ul full-width">
        <div class="row">
          <div>좌표</div>
          <div style="flex:0 0 25px" />
          <div class="row col" style="align-items:center;">
            <div class="col" style="height:1px;border-bottom:1px dashed #999999" />
          </div>
        </div>
        <div v-for="(pt, index) in field.roi" :key="`${index}`" class="item-row row full-width">
          <div style="flex:0 0 20px" />
          <div v-if='index == 0'>{{ 'left-top' }}</div>
          <div v-if='index == 1'>{{ 'right-top' }}</div>
          <div v-if='index == 2'>{{ 'right-bottom' }}</div>
          <div v-if='index == 3'>{{ 'left-bottom' }}</div>
          <q-space />
          <div>
            <div><span class="text-grey">{{`[${Number(pt[0]).toFixed(1)}, ${Number(pt[1]).toFixed(1)}]`}}</span></div>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</q-expansion-item>
</template>
<script>
export default {
  props: ['field'],
  data: function () {
    return {
      state: {
        unfold: false
      }
    }
  },
  methods: {
    listen__x__ontoggle(e, show) {
      if (e != undefined)
        this.$emit('ontoggle', {elment: this.$el, show})
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.item-row {
  display:flex;
  flex-direction:row;
  height:30px;
  align-items: center;
  justify-content: space-between;
}
.my-ul {
  display:flex;
  flex-direction:column;
  margin-top: 4px;
}
.my-ul > .item-row {
  height: 16px;
  font-size: 12px;
}
.badge-wrapper > *:not(:last-child) {
  margin-right: 3px;
}
</style>
